export enum Route {
  LOGIN = 'login',
  DASHBOARD = 'dashboard'
}
